export const compareObj = (newObj, oldObj) => {
  const arr = []
  Object.keys(oldObj).forEach(key => {
    const temp = {}
    if (key !== 'localId') {
      if (oldObj[key] !== newObj[key]) {
        temp.new = newObj[key]
        temp.old = oldObj[key]
        temp.changedKey = key
        arr.push(temp)
      }
    }
  })
  if (arr.length) {
    return arr
  }
  return false
}

export const compareArray = (arr1, arr2) => {
  const temp = []
  arr1.forEach((_, ind) => {
    if (arr1[ind] && arr2[ind]) {
      const res = compareObj(arr1[ind], arr2[ind])
      if (res) {
        res.forEach(el => {
          temp.push({
            ...el,
            card: ind + 1,
          })
        })
      }
    }
  })
  return temp
}
